export class AuthExchangeForm {
  id: number

  apiKey: string

  secret: string

  newSecret?: string
}
